var TREATMENT_NAME_DELIMITER = '_';
var TREATMENT_NAME_COMPONENTS_COUNT = 4;
export var LINE_OF_BUSINESS_FIELD = 'lineOfBusiness';
export var EXPERIMENT_FAMILY_FIELD = 'experimentFamily';
export var EXPERIMENT_ITERATION_FIELD = 'experimentIteration';
export var TREATMENT_VARIATION_FIELD = 'treatmentVariation';
export var createEmptyPayload = function createEmptyPayload() {
  var _ref;

  return _ref = {}, _ref[LINE_OF_BUSINESS_FIELD] = '', _ref[EXPERIMENT_FAMILY_FIELD] = '', _ref[EXPERIMENT_ITERATION_FIELD] = '', _ref[TREATMENT_VARIATION_FIELD] = '', _ref;
};
export var parseTreatmentFields = function parseTreatmentFields(treatmentName) {
  var _ref2;

  if (typeof treatmentName === 'undefined' || treatmentName === null) {
    return createEmptyPayload();
  }

  var nameComponents = treatmentName.split(TREATMENT_NAME_DELIMITER);

  if (nameComponents.length !== TREATMENT_NAME_COMPONENTS_COUNT) {
    return createEmptyPayload();
  }

  return _ref2 = {}, _ref2[LINE_OF_BUSINESS_FIELD] = nameComponents[0], _ref2[EXPERIMENT_FAMILY_FIELD] = nameComponents[1], _ref2[EXPERIMENT_ITERATION_FIELD] = nameComponents[2], _ref2[TREATMENT_VARIATION_FIELD] = nameComponents[3], _ref2;
};